module.exports = __webpack_public_path__ + "static/media/arvore-2.b51ed218.png";